import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { apiRequestStringifier } from "./mcn-helpers";
import snakeCase from "lodash-es/snakeCase";
export default class UrlManager {
  static getQueryString(urlManagers) {
    let query = (Array.isArray(urlManagers) ? urlManagers : [urlManagers]).map(urlManager => {
      if (!(urlManager instanceof UrlManager)) return;
      let object = urlManager.getQueryObject();
      return Object.keys(object).map(paramKey => object[paramKey] ? [snakeCase(paramKey), object[paramKey]].filter(p => p).join('=') : null).filter(param => param).join('&');
    }).filter(urlManager => urlManager).join('&');
    return query.length ? ['?', query].join('') : '';
  }
  getQueryObject() {
    return JSON.parse(JSON.stringify(this, apiRequestStringifier));
  }
  getQueryString() {
    let object = this.getQueryObject();
    let query = Object.keys(object).map(paramKey => object[paramKey] ? [snakeCase(paramKey), object[paramKey]].filter(p => p).join('=') : null).filter(param => param).join('&');
    return query.length ? ['?', query].join('') : '';
  }
}